import * as R from 'ramda';
import { ExistingProject, UnsavedProject } from './Project';

export const copyProject = (saveAsName: string) =>
  R.pipe<[ExistingProject], ExistingProject, UnsavedProject>(
    R.assoc('name', saveAsName),
    R.omit(['id', 'createdAt', 'modifiedAt'])
  );
